<div id="close-screen" [style.backgroundImage]="'url(' + backgroundImage + ')'">
  <div class="information-wrapper">
    <div class="information p-1">
      <h1>{{ 'closeScreen' | i18n }}</h1>
      <FreeDial></FreeDial>
    </div>
  </div>
</div>
